export enum ESaveSubdomainErrorCodes {
    DOMAIN_ALREADY_EXISTS = 'DOMAIN_ALREADY_EXISTS',
    INVALID_DOMAIN = 'INVALID_DOMAIN',
}

export enum ESavePageErrorCodes {
    PAGE_NAME_ALREADY_USED = 'PAGE_NAME_ALREADY_USED',
    PAGE_URL_ALREADY_USED = 'PAGE_URL_ALREADY_USED',
    PAGE_URL_INVALID = 'PAGE_URL_INVALID',
    PAGE_URL_RESERVED = 'PAGE_URL_RESERVED',
}

export enum ESaveNameErrorCodes {
    SITE_NAME_ALREADY_USED = 'SITE_NAME_ALREADY_USED',
}

export enum ESaveErrors {
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
